import { Pagination } from "@/components/shared/pagination";
import { cn } from "@/lib/utils";
import { SelectPageItem } from "./select-page-item";
import { NoOfCountRecord } from "./no-of-count-record";

type ListFooterProps = {
  className?: string;
  perPage: number;
  onPerPageChange: (prop: number) => void;
  page: number;
  onPageChange: (prop: number) => void;
  totalItem: number;
  isEmpty?: boolean;
};

export const ListFooter = ({
  perPage,
  onPerPageChange,
  page,
  onPageChange,
  className,
  totalItem,
  isEmpty,
}: ListFooterProps) => {
  return (
    <div
      className={cn(
        "flex md:items-center md:flex-row flex-col md:justify-between",
        className
      )}
    >
      <Pagination
        total={totalItem}
        value={page}
        onChange={onPageChange}
        recordPerPage={perPage}
      />
      {isEmpty ? null : (
        <NoOfCountRecord perPage={perPage} totalItem={totalItem} page={page} />
      )}
      <SelectPageItem value={perPage} onChange={onPerPageChange} />
    </div>
  );
};
